import Vue from 'vue';
import VueMask from 'v-mask';
import App from './App.vue';
import router from './router';
import store from './store';
import mainOidc from '@/service/oidc';
import Vue2Filters from 'vue2-filters';
import SignalR from './plugins/signalR';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;

Vue.use(VueMask);
Vue.use(Vue2Filters);
Vue.use(SignalR);
Vue.use(VueSweetalert2);

Vue.use(VCalendar);

const hostname = window.location.hostname;
if (hostname.includes('lorranaleiloes')) {
  document.title = process.env.VUE_APP_SITE_NAME_LORRANA;
} else if (hostname.includes('ruamgotardoleiloes')) {
  document.title = process.env.VUE_APP_SITE_NAME_RUAM;
} else {
  document.title = process.env.VUE_APP_SITE_NAME;
}

document.querySelector("link[rel~='icon']").href = process.env.VUE_APP_FAVICON;

mainOidc.startup().then((ok) => {
  if (ok) {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
